import { CategoryRounded, DisplaySettingsRounded, KeyRounded, MapRounded, QuestionMarkRounded, TaskRounded } from '@mui/icons-material';
import { Avatar, IconButton, Stack, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { AccountMenu, Image, Protect, Scrollbar } from 'app/components';
import { DriverRoundedIcon, TrailerRoundedIcon, TransportGroupRoundedIcon, TransportRoundedIcon, UserRoundedIcon } from 'app/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  const { session } = useSelector((state) => state.session);
  const [profileRef, setProfileRef] = useState(null);

  const handleProfileOpen = (event) => {
    setProfileRef(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileRef(null);
  };

  return (
    <Stack
      direction='row'
      flexDirection='column'
      sx={(theme) => ({
        width: '60px',
        zIndex: theme.zIndex.sidebar,
        bgcolor: theme.palette.primary.dark,
        borderRight: '1px solid ' + theme.palette.primary.dark,
      })}>
      <Stack
        direction='row'
        justifyContent='center'
        sx={{
          padding: '16px 16px 32px',
          img: {
            minHeight: '40px',
            maxHeight: '40px',
            verticalAlign: 'middle',
          },
        }}>
        <Image name='logo.svg' alt='logo-brand' />
      </Stack>
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='center'
        sx={(theme) => ({
          flex: '1 1 auto',
          display: 'flex',
          overflow: 'hidden',
          '.simplebar-container': {
            width: '100%',
          },
          '.simplebar-vertical': {
            right: '0',
            width: '8px!important',
          },
          '.simplebar-scrollbar': {
            '&:before': {
              backgroundColor: alpha(theme.palette.primary.light, 0.52) + '!important',
            },
            '&.simplebar-hover:before': {
              backgroundColor: alpha(theme.palette.primary.light, 0.62) + '!important',
            },
          },
        })}>
        <Scrollbar autoHide>
          <Stack
            direction='row'
            flexDirection='column'
            component='ul'
            sx={(theme) => ({
              width: '100%',
              padding: '0',
              margin: '0',
              listStyle: 'none',
              a: {
                position: 'relative',
                display: 'flex',
                padding: '8px',
                margin: '4px 10px',
                color: theme.palette.primary.light,
                textAlign: 'center',
                alignItems: 'center',
                transition: 'color .3s, background-color .3s',
                verticalAlign: 'middle',
                justifyContent: 'center',
                borderRadius: theme.shape.borderRadius,
                '&:hover': {
                  cursor: 'pointer',
                },
                '&.selected': {
                  color: theme.palette.primary.contrastText,
                  bgcolor: alpha(theme.palette.primary.main, 0.32),
                  path: {
                    fill: theme.palette.primary.contrastText,
                  },
                },
                path: {
                  fill: theme.palette.primary.light,
                },
              },
              '.MuiDivider-root': {
                margin: theme.spacing(2, 0),
                borderColor: alpha(theme.palette.primary.light, 0.32),
              },
            })}>
            <Protect
              permissions={['read', 'activity']}
              renderPermitted={() => (
                <li>
                  <Tooltip title='Карта' placement='right' arrow>
                    <NavLink to='/map' activeClassName='selected'>
                      <MapRounded />
                    </NavLink>
                  </Tooltip>
                </li>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['create', 'update', 'delete', 'read+']}
              renderPermitted={() => (
                <React.Fragment>
                  <li>
                    <Tooltip title='Транспорт' placement='right' arrow>
                      <NavLink to='/transport' activeClassName='selected'>
                        <TransportRoundedIcon />
                      </NavLink>
                    </Tooltip>
                  </li>
                </React.Fragment>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['create', 'update', 'delete']}
              renderPermitted={() => (
                <React.Fragment>
                  <li>
                    <Tooltip title='Прицепы' placement='right' arrow>
                      <NavLink to='/trailer' activeClassName='selected'>
                        <TrailerRoundedIcon />
                      </NavLink>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title='Пользователи' placement='right' arrow>
                      <NavLink to='/user' activeClassName='selected'>
                        <UserRoundedIcon />
                      </NavLink>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title='Водители' placement='right' arrow>
                      <NavLink to='/driver' activeClassName='selected'>
                        <DriverRoundedIcon />
                      </NavLink>
                    </Tooltip>
                  </li>
                </React.Fragment>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['checklist_update']}
              renderPermitted={() => (
                <li>
                  <Tooltip title='Пользователи' placement='right' arrow>
                    <NavLink to='/user' activeClassName='selected'>
                      <UserRoundedIcon />
                    </NavLink>
                  </Tooltip>
                </li>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['create', 'update', 'delete']}
              renderPermitted={() => (
                <React.Fragment>
                  <li>
                    <Tooltip
                      title={
                        <span>
                          Дивизионы
                          <br />
                          Автоколонны
                          <br />
                          Группы транспорта
                        </span>
                      }
                      placement='right'
                      arrow>
                      <NavLink to='/transport-group' activeClassName='selected'>
                        <TransportGroupRoundedIcon />
                      </NavLink>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title='Группы геозон' placement='right' arrow>
                      <NavLink to='/geofence-group' activeClassName='selected'>
                        <CategoryRounded />
                      </NavLink>
                    </Tooltip>
                  </li>
                </React.Fragment>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['create', 'update', 'delete']}
              renderPermitted={() => (
                <React.Fragment>
                  <li>
                    <Tooltip title='Токены' placement='right' arrow>
                      <NavLink to='/token' activeClassName='selected'>
                        <KeyRounded />
                      </NavLink>
                    </Tooltip>
                  </li>
                </React.Fragment>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions={['checklist_read']}
              renderPermitted={() => (
                <React.Fragment>
                  <li>
                    <Tooltip title='Чеклисты' placement='right' arrow>
                      <NavLink to='/checklist' activeClassName='selected'>
                        <TaskRounded />
                      </NavLink>
                    </Tooltip>
                  </li>
                </React.Fragment>
              )}
              renderForbidden={() => <React.Fragment />}
            />
          </Stack>
        </Scrollbar>
      </Stack>
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='center'
        sx={(theme) => ({
          gap: '12px',
          padding: '16px 0 16px',
          '.MuiButtonBase-root': {
            maxWidth: '36px',
            maxHeight: '36px',
            color: theme.palette.primary.light,
          },
          '.MuiButtonBase-root.MuiIconButton-colorPrimary': {
            bgcolor: alpha(theme.palette.primary.light, 0.32),
            'a.selected svg': {
              color: theme.palette.primary.contrastText,
            },
          },
          '.MuiAvatar-root': {
            width: '36px',
            height: '36px',
          },
        })}>
        <Protect
          permissions={['create']}
          renderPermitted={() => (
            <Tooltip title='Помощь/Заявки' placement='right' arrow>
              <IconButton color='primary'>
                <NavLink to='/issue' activeClassName='selected'>
                  <QuestionMarkRounded
                    sx={(theme) => ({
                      marginTop: '5px',
                      color: theme.palette.primary.light,
                    })}
                  />
                </NavLink>
              </IconButton>
            </Tooltip>
          )}
          renderForbidden={() => <React.Fragment />}
        />
        <Protect
          permissions={['create']}
          renderPermitted={() => (
            <Tooltip title='Настройки' placement='right' arrow>
              <IconButton color='primary'>
                <NavLink to='/settings' activeClassName='selected'>
                  <DisplaySettingsRounded
                    sx={(theme) => ({
                      marginTop: '5px',
                      color: theme.palette.primary.light,
                    })}
                  />
                </NavLink>
              </IconButton>
            </Tooltip>
          )}
          renderForbidden={() => <React.Fragment />}
        />
        <Tooltip title='О пользователе/Выход' placement='right' arrow>
          <IconButton ref={profileRef} color={profileRef ? 'primary' : 'inherit'} onClick={handleProfileOpen}>
            <Avatar>
              <Image name={`avatar-${session.role_id}.png`} alt={`avatar-${session.role_id}`} />
            </Avatar>
          </IconButton>
        </Tooltip>
        <AccountMenu open={!!profileRef} onClose={handleProfileClose} anchorEl={profileRef} />
      </Stack>
    </Stack>
  );
};

export default Sidebar;
